module.exports = __webpack_public_path__ + "img/SMT_04_Mr_Derek_Tan_Yip_Teck.2629bad7.jpg";